/**
 * Export progress modal
 * Story 464: Export full project data as a downloadable zip of markdown files
 *
 * Simple spinner modal shown while export is preparing.
 */

import { useEffect } from 'react';
import './ExportModal.css';

interface ExportModalProps {
  onCancel: () => void;
}

export function ExportModal({ onCancel }: ExportModalProps) {
  // Close on Escape
  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        e.preventDefault();
        onCancel();
      }
    }

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onCancel]);

  return (
    <div className="export-modal__backdrop">
      <div className="export-modal" role="dialog" aria-label="Export in progress">
        <div className="export-modal__spinner" />
        <p className="export-modal__message">Preparing your project export...</p>
      </div>
    </div>
  );
}
